import intermind from '../../index';
import { BaseFeedbackForm, IssueForm, IdeaForm } from './types';

function createDiagnosticInfo(): Blob {
  const info = {
    url: window.location.href,
    userAgent: navigator.userAgent,
    screenSize: `${window.screen.width}x${window.screen.height}`,
    viewportSize: `${window.innerWidth}x${window.innerHeight}`,
    timestamp: new Date().toISOString(),
  };

  return new Blob([JSON.stringify(info, null, 2)], { type: 'application/json' });
}

function fillCommonFormData(formData: FormData, data: BaseFeedbackForm): void {
  formData.append('message', data.message);
  formData.append('agreeToContact', String(data.agreeToContact));
  if (data.language) {
    formData.append('language', data.language);
  }
  if (data.screenshotBlob) {
    formData.append('screenshot', data.screenshotBlob, 'screenshot.jpg');
  }
  if (data.email) {
    formData.append('email', data.email);
  }

  formData.append('diagnosticInfo', createDiagnosticInfo(), 'diagnostic.json');

  interface Window {
    __CONSOLE_LOGGER?: object;
  }

  const consoleLogger = (window as Window).__CONSOLE_LOGGER as { getLogBlob?: () => Blob } | undefined;
  if (consoleLogger?.getLogBlob) {
    const logBlob = consoleLogger.getLogBlob();
    formData.append('consoleLogs', logBlob, 'console-logs.json');
  }
}

export class FeedbackResource {
  async reportIssue(data: IssueForm): Promise<boolean> {
    const formData = new FormData();

    fillCommonFormData(formData, data);
    formData.append('category', data.category);

    try {
      const res = await intermind.httpClient.post('/feedback/issues', formData, {
        headers: { 'Content-Type': undefined },
      });
      return res.status >= 200 && res.status < 300;
    } catch (error) {
      console.error('Failed to send issue:', error);
      return false;
    }
  }

  async sendIdea(data: IdeaForm): Promise<boolean> {
    const formData = new FormData();
    fillCommonFormData(formData, data);

    try {
      const res = await intermind.httpClient.post('/feedback/ideas', formData, {
        headers: { 'Content-Type': undefined },
      });
      return res.status >= 200 && res.status < 300;
    } catch (error) {
      console.error('Failed to send idea:', error);
      return false;
    }
  }
}
